import React from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import { VariantPickerSharedProperties, VariantPickerVariation_Color } from "../utils";
import { FONTS } from "../../../../../styles/fonts";
import { SwarovskiLink } from "../../../../../components/_shared-components/ui-elements/SwarovskiLink";

export const ColoredVariantView: ReactTFC<{
  variation: Omit<VariantPickerVariation_Color, "tag">;
  action: VariantPickerSharedProperties["target"];
}> = props => {
  const styles = css`
    border: 3px solid transparent;

    .active &,
    .enabled & {
      border: 3px solid ${CSS_COLORS.White};

      box-shadow: rgb(31 112 87 / 50%) 0px 0px 10px 0px;
    }

    position: relative;

    &:after {
      content: "";
      position: absolute;

      width: calc(100% + 6px);
      height: calc(100% + 6px);

      left: -5px;
      top: -5px;

      border-radius: 100%;
      border: 2px solid transparent;
    }

    --outline-color: ${CSS_COLORS.Green};

    .active & {
      &:after {
        border: 2px solid var(--custom--outline-color, --outline-color);
        filter: saturate(0.8) brightness(0.7);
      }
    }

    .enabled & {
      &:after {
        border: 2px solid ${CSS_COLORS.Grey6};
      }
    }

    --size: 41px;

    width: var(--size);
    height: var(--size);
    border-radius: 50%;

    display: inline-block;
  `;

  const style = {
    backgroundColor: props.variation.colorHex,
    "--custom--outline-color": props.variation.colorHex,
  } as React.CSSProperties;
  return (
    <div
      className="u-flex u-flex-col u-relative"
      css={css`
        gap: 6px;
      `}
    >
      {(props.action.tag == "click" || props.action.tag === "disabled") && (
        <button
          aria-label={props.variation.name}
          onClick={props.action.tag === "disabled" ? undefined : props.action.onClick.action}
          disabled={props.action.tag === "disabled"}
          style={style}
          css={styles}
        />
      )}

      {props.action.tag == "link" && (
        <SwarovskiLink
          isInternal={true}
          scrollToTop={false}
          expectSimilarLayout={true}
          link={props.action.link}
          styled={"no-decoration"}
          attachStyles={styles}
          style={style}
        />
      )}

      {props.variation.state === "selected" ? (
        <span
          className="u-ta-center u-absolute"
          css={[
            FONTS.SwarovskiFutura300,
            css`
              top: calc(100% + 8px);
              left: 50%;
              transform: translateX(-50%);
            `,
          ]}
        >
          {props.variation.name}
        </span>
      ) : null}
    </div>
  );
};
